// extracted by mini-css-extract-plugin
export var component = "Header-module--component--lI9lD";
export var header = "Header-module--header--Kt97u";
export var menus = "Header-module--menus--8YhDM";